/**
 * @fileoverview TrayHide: the "Hide" at a tray's foot (B158). A 40px primary button, centred, that shuts the tray above it. The
 * plant card hand-built it three times (the tiles' trays, the Care strip and the planting strip); this is the one copy. The
 * caller gives the word (plants.card.tiles.hide) so the component holds none.
 *
 * Where: no caller yet; the plant card's trays and the bed card's trays adopt it in B158 jobs 3 and 7.
 * API: none.
 * Words: none; the caller gives them.
 *
 * @module TrayHide
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

/** What the button is given, and any button attribute. */
export interface TrayHideProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** The word ("Hide"). */
  children?: React.ReactNode;
}

/**
 * The Hide button.
 *
 * @param props - TrayHideProps.
 */
export const TrayHide: React.FC<TrayHideProps> = ({ className, children, ...rest }) => (
  <button
    type="button"
    className={cn(
      'mx-auto flex min-h-10 w-full items-center justify-center rounded-md text-[0.8125rem] font-semibold text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-ring',
      className,
    )}
    {...rest}
  >
    {children}
  </button>
);
